<ng-template let-sublist="sublist" #evidencesList>
  <ng-content></ng-content>
  <ul>
    @for (evidence of sublist; track evidence.id) {
      <li
        class="evidence-result"
        role="option"
        tabindex="0"
        [class.selected]="selectedEvidence()?.id === evidence.id"
        [attr.aria-selected]="selectedEvidence()?.id === evidence.id"
        (click)="toggleSelected(evidence)"
        (keydown.enter)="toggleSelected(evidence)"
        (keydown.space)="toggleSelected(evidence)"
      >
        <div class="evidence-name">
          <span [innerHTML]="evidence.name | highlightMatches: searchText()"></span>
          ({{ evidence.mostRecentUploadedAt | date: 'shortDate' }})
        </div>
        <p class="evidence-details">
          @for (fileAttachment of evidence.fileAttachments; track fileAttachment.id) {
            <span class="file-attachment">
              <comp-file-type
                [file]="{
                  ...fileAttachment,
                  confirmReuse: false,
                }"
              ></comp-file-type>
              <span class="downloadable-file-name">
                <span [innerHTML]="fileAttachment.filename | highlightMatches: searchText()"></span>
                <div class="download-hover">
                  <button
                    (click)="
                      downloadService.downloadFileAttachment(fileAttachment);
                      $event.stopPropagation()
                    "
                  >
                    <i class="ul-button__icon-left ul-icon -small">download</i>
                    <span>&nbsp;Download</span>
                  </button>
                </div>
              </span>
            </span>
          }
        </p>
        @if (evidenceFilter() === 'OTHER_REVISION') {
          <p class="evidence-details">
            {{
              'requirementIntake.evidence.reuse.evidenceDetails.revision'
                | translate: { revision: evidence.revisionName }
            }}
          </p>
        } @else if (evidenceFilter() === 'OTHER_PRODUCT') {
          <p class="evidence-details">
            {{
              'requirementIntake.evidence.reuse.evidenceDetails.productAndRevision'
                | translate: { product: evidence.productName, revision: evidence.revisionName }
            }}
          </p>
        }
      </li>
    }
  </ul>
</ng-template>

@if (searchText()) {
  <p class="list-header">
    {{
      'requirementIntake.evidence.reuse.listHeaders.searchResults'
        | translate: { searchText: searchText() }
    }}
  </p>
} @else {
  <p class="list-header">
    {{ 'requirementIntake.evidence.reuse.listHeaders.recentlyUploaded' | translate }}
  </p>
}

@if (evidences().length === 0) {
  <p translate="requirementIntake.evidence.reuse.emptyState"></p>
} @else {
  <ng-container
    [ngTemplateOutlet]="evidencesList"
    [ngTemplateOutletContext]="{ sublist: recommended() }"
  >
    @if (recommended().length > 0 && other().length) {
      <p class="category-header">
        <i comp-icon>star</i>
        <span translate="requirementIntake.evidence.reuse.listHeaders.recommended"></span>
      </p>
    }
  </ng-container>

  <ng-container [ngTemplateOutlet]="evidencesList" [ngTemplateOutletContext]="{ sublist: other() }">
    @if (recommended().length > 0 && other().length) {
      <p class="category-header">
        @if (searchText()) {
          <i comp-icon>search</i>
        } @else {
          <i comp-icon>history</i>
        }
        <span translate="requirementIntake.evidence.reuse.listHeaders.other"></span>
      </p>
    }
  </ng-container>
}
